import { groupBy } from 'lodash';
import { UnitStateGroupEnumType } from '@mark43/cad-api';
import { useCallback, useMemo } from 'react';
import { useUnitStateTransitions } from '../../unit-status/use-unit-state-transitions';

export function useCanTransitionToUnitStateGroup(
    unitStateId: number | undefined
): (unitStateGroup: UnitStateGroupEnumType) => boolean {
    const validStatuses = useUnitStateTransitions(unitStateId);
    const validStatusesByUnitStateGroup = useMemo(
        () => groupBy(validStatuses, (status) => status.unitStateGroup),
        [validStatuses]
    );
    return useCallback(
        (unitStateGroup: UnitStateGroupEnumType): boolean => {
            return (
                validStatusesByUnitStateGroup[unitStateGroup] !== undefined &&
                validStatusesByUnitStateGroup[unitStateGroup].length > 0
            );
        },
        [validStatusesByUnitStateGroup]
    );
}
